import { Box, Dialog, useMediaQuery, useTheme } from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { InfoWindow } from '@vis.gl/react-google-maps';
import React from 'react';
import { useMapContext } from '../../contexts/MapContext/MapContext';

const GoogleInfoWindow: React.FC = () => {
  const { selectedMarker, selectedIcon, setSelectedMapIcon } = useMapContext();
  const myPopupDef = selectedIcon?.module?.displayConfig?.popupDef || null;
  const icon = selectedIcon?.icon;
  const module = selectedIcon?.module as ModuleConfig;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isDialog =
    module?.displayConfig?.isPopupDialog ||
    (module?.displayConfig?.isMobilePopupDialog && !isDesktop) ||
    false;

  if (!myPopupDef) return;

  if (myPopupDef && !isDialog) {
    return (
      <InfoWindow
        key={icon?.id}
        className="map-popup"
        headerDisabled
        anchor={selectedMarker}
        onClose={() => {
          setSelectedMapIcon(null, null);
        }}
        shouldFocus={true}
        disableAutoPan={false}
      >
        <Box sx={{ color: 'black' }}>
          {React.createElement(myPopupDef, {
            icon: selectedIcon,
            module: module,
          })}
        </Box>
      </InfoWindow>
    );
  } else {
    return <DialogInfoWindow />;
  }
};

const DialogInfoWindow: React.FC = () => {
  const { selectedMarker, selectedIcon, setSelectedMapIcon } = useMapContext();
  const myPopupDef = selectedIcon?.module?.displayConfig?.popupDef || null;
  const icon = selectedIcon?.icon;
  const module = selectedIcon?.module as ModuleConfig;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Dialog
      open={Boolean(selectedMarker)}
      onClose={() => {
        setSelectedMapIcon(null, null);
      }}
      sx={{
        backgroundColor: 'none',
        p: 0,
        overflow: 'visible',
        borderRadius: '20px',
        '& .MuiPaper-root': {
          background: 'none',
          borderRadius: '20px',
          p: 0,
          m: 0,
          boxShadow: '1px 1px 1px rgba(114, 107, 107, 0.5)',
          width: isDesktop ? '100%' : '90%',
        },
      }}
    >
      {myPopupDef ? (
        <Box
          sx={{
            borderRadius: '20px',
            '& .MuiPaper-root': {
              width: 'auto',
            },
          }}
        >
          {React.createElement(myPopupDef, {
            icon: selectedIcon,
            module: module,
          })}
        </Box>
      ) : (
        <Box sx={{ color: 'black' }}>{JSON.stringify(icon)}</Box>
      )}
    </Dialog>
  );
};

export default GoogleInfoWindow;
